export default function ({ redirect, store, route }) {
  // const user = store.getters["auth/getUser"]
  // if (user && user.kvkk === false && route.fullPath !== "/user/profile/edit") {
  //   return redirect("/user/profile/edit")
  // }
}
